import React, { useEffect, useState } from 'react';
import { getDept, deleteDept } from '../../api/deptApi';
import { 
  Card, 
  CardContent, 
  Typography, 
  Divider, 
  Stack, 
  Box, 
  Button, 
  Avatar 
} from '@mui/material';
import {
  CorporateFare,
  Tag,
  AccountTree,
  Badge,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

function DeptView({ code, onEdit, onDeleted  }) {
  const [dept, setDept] = useState(null);

  useEffect(() => {
    getDept(code).then(res => setDept(res.data));
  }, [code]);

  if (!dept) return <p>불러오는 중...</p>;

  const handleDelete = async () => {
    if (window.confirm('정말 이 부서를 삭제하시겠습니까?')) {
      try {
        await deleteDept(code);
        alert('부서가 삭제되었습니다.');
        if (onDeleted) onDeleted(); // ✅ 상위 컴포넌트에 알림
      } catch (err) {
        alert('삭제 실패: ' + err.message);
      }
    }
  };

  return (
    <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e4e8', bgcolor: '#fff' }}>
      <Box sx={{ height: 6, bgcolor: '#1976d2' }} />
      <CardContent sx={{ p: 3 }}>
        <Stack spacing={3}>
          {/* 헤더 섹션 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: '#e3f2fd', color: '#1976d2' }}>
              <CorporateFare />
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                {dept.dept_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                부서 상세 정보
              </Typography>
            </Box>
          </Box>

          <Divider />

          {/* 정보 리스트 */}
          <Stack spacing={2.5}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 120, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Tag fontSize="small" sx={{ color: '#adb5bd' }} />
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#495057' }}>부서 코드</Typography>
              </Box>
              <Typography variant="body2" sx={{ color: '#212529' }}>{dept.dept_code}</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 120, display: 'flex', alignItems: 'center', gap: 1 }}>
                <AccountTree fontSize="small" sx={{ color: '#adb5bd' }} />
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#495057' }}>상위 부서</Typography>
              </Box>
              <Typography variant="body2" sx={{ color: '#212529' }}>
                {dept.parent_dept_name ? `${dept.parent_dept_name} (${dept.parent_dept_code})` : '없음 (최상위)'}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 120, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Badge fontSize="small" sx={{ color: '#adb5bd' }} />
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#495057' }}>담당자 ID</Typography>
              </Box>
              <Typography variant="body2" sx={{ color: '#212529' }}>{dept.manager_userid || '-'}</Typography>
            </Box>
          </Stack>

          <Divider />

          {/* 액션 버튼 */}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => onEdit(code)}
              sx={{ bgcolor: '#4e73df', '&:hover': { bgcolor: '#2e59d9' } }}
            >
              편집
            </Button>
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              onClick={handleDelete}
            >
              삭제
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default DeptView;